import React from "react";
import { Label, FormFeedback } from "reactstrap";
import Flatpickr from "react-flatpickr";
import classNames from "classnames";

const DatePicker = ({
  label,
  mode = "single",
  value,
  placeholder,
  setValues,
  name,
  enableTime = false,
  minDate,
  isrequired,
  invalid,
  error_msg,
}) => {
  const handleDateChange = (val) => {
    setValues((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  return (
    <div className="mb-3">
      {label && (
        <Label className="form-label">
          {label}
          {isrequired && <span className="text-danger ms-1">*</span>}
        </Label>
      )}

      <Flatpickr
        className={classNames(
          "form-control form-control-sm",
          invalid && "is-invalid"
        )}
        value={value}
        options={{
          enableTime,
          dateFormat: enableTime ? "Y-m-d H:i" : "Y-m-d",
          mode,
          minDate,
        }}
        onChange={handleDateChange}
        placeholder={placeholder}
      />

      {invalid && error_msg && (
        <FormFeedback className="d-block">
          {error_msg}
        </FormFeedback>
      )}
    </div>
  );
};

export default DatePicker;

